import { ChangeAddressComponent } from './containers/change-address/change-address.component';
import { ChangeOwnerComponent } from './containers/change-owner/change-owner.component';
import { ChipDetailViewComponent } from './containers/chip-detail-view/chip-detail-view.component';
import { Routes } from '@angular/router';

export const registeredChipsRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./containers/chip-grid-view/chip-grid-view.component').then(
                (m) => m.ChipGridViewComponent,
            ),
    },
    {
        path: ':code',
        loadComponent: () =>
            import('./containers/code-page-wrapper/code-page-wrapper.component').then(
                (m) => m.CodePageWrapperComponent,
            ),
            children: [
                {
                    path: '',
                    component: ChipDetailViewComponent,
                },
                {
                    path: 'change-owner',
                    component: ChangeOwnerComponent,
                },
                {
                    path: 'change-address',
                    component: ChangeAddressComponent,
                },
                {
                    path: '**',
                    redirectTo: '',
                },
            ]
    },
    {
        path: '**',
        redirectTo: '',
    },
];
